
























































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ITicket, ITicketMessage } from "@/models/tickets";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import HasValidation from "@/mixins/HasValidation";

@Component
export default class DeleteTicketMessageModal extends Mixins(
  HasValidation,
  Context
) {
  // Props
  @Prop({ required: true })
  public ticketId!: ITicket["id"];

  @Prop({ required: true })
  public ticketMessageId!: ITicketMessage["id"];

  @Prop({ default: false })
  public isClientMessage!: boolean;

  // Data
  public reason = "";
  public isProcessing = false;

  public async deleteMessage() {
    try {
      if (!(await this.validate())) return;
      this.isProcessing = true;
      const response = await this.$store.dispatch(
        `data/${DataModules.TICKETS_MESSAGES}/deleteMessage`,
        {
          ticketId: this.ticketId,
          messageId: this.ticketMessageId,
          data: {
            reason: this.reason
          }
        }
      );
      this.$emit("success", { ticketMessage: response });
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
